import React from "react";
import { useNavigate } from "react-router-dom";

const WalkingTheWalk = () => {
  const navigate = useNavigate();
  const caseStudies = [
    {
      id: 1,
      title: "Scaling Telco CVM with AWS MLOps",
      description:
        "Replaced manual, intuition-led campaigns with a cloud-native MLOps engine for real-time, ML-powered customer engagement. The solution improved campaign precision, enhanced user segmentation, and enabled smarter activation across channels—leading to stronger customer lifetime value and measurable business impact.",
      image: "/images/case-studies/case-study1.png",
      slug: "scaling-cvm-with-aws-mlops",
    },
    {
      id: 2,
      title: "Driving Retail Uplift with AI-Powered Shelf Analytics",
      description:
        "Deployed computer vision and ML models using CCTV footage to optimize product placement and in-store visibility. The approach reduced dependency on manual audits, enabled real-time shelf insights, and helped drive store-level performance uplift across key SKUs and categories.",
      image: "/images/case-studies/case-study2.png",
      slug: "retail-shelf-analytics-with-ai",
    },
    {
      id: 3,
      title: "Accelerating Legacy ETL Migration with Agentic AI",
      description:
        "Used a GenAI-powered multi-agent framework to automate migration of legacy ETL pipelines. By parsing source logic, generating target code, and independently executing tasks, the solution streamlined cloud migration efforts—reducing time, lowering manual effort, and freeing up engineering bandwidth for higher-value work.",
      image: "/images/case-studies/case-study3.png",
      slug: "etl-migration-agentic-ai",
    },
  ];

  const renderCardTitle = (title, highlight, metric) => {
    if (!highlight || !metric) {
      return title;
    }

    const parts = title.split(highlight);
    return (
      <>
        {parts[0]}
        <span className="text-fluoro-green">
          {highlight} {metric}
        </span>{" "}
        {parts[1].replace(metric, "")}
      </>
    );
  };

  return (
    <div className="w-full bg-white py-12 lg:py-18">
      <div className="w-[88%] lg:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 lg:mb-12">
          <h2 className="text-[32px] lg:text-[48px] xl:text-[56px] text-dark-blue RoobertLight leading-[120%] mb-2">
            Walking the walk
          </h2>
          <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-dark-blue RoobertMedium leading-[120%]">
            Real deployments. Meaningful impact.
          </h3>
        </div>

        {/* Outcome Cards Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-8 lg:mb-8">
          {caseStudies.map((study, index) => (
            <div
              key={study.id}
              className="relative bg-dark-blue cursor-pointer"
              onClick={() => navigate(`/caseStudies/${study.slug}`)}
            >
              {/* Image/Media Section */}
              <div className="relative bg-gray-300 h-48 md:h-56">
                <img
                  src={study.image}
                  alt={study.title}
                  className="w-full h-full object-cover"
                />
                {/* Green L-shaped border on top-right of image */}
                <div className="border-r-4 border-t-4 border-fluoro-green absolute top-0 right-0 w-16 h-16"></div>
              </div>

              {/* Content Section */}
              <div className="bg-dark-blue p-6 md:p-8">
                <h3 className="RoobertMedium text-lg md:text-xl font-bold text-white mb-4 leading-tight">
                  {study.title}
                </h3>
                <p className="RoobertRegular text-sm md:text-base text-white leading-relaxed mb-4">
                  {study.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Concluding Statement */}
        <div>
          <p className="text-[#1E1E1E] RoobertRegular text-[16px] lg:text-[18px] leading-[140%]">
            These aren't pilots or demos. They're results delivered in
            production - in ASEAN's leading banks, telcos, and retailers
          </p>
        </div>
      </div>
    </div>
  );
};

export default WalkingTheWalk;
